import React, { ChangeEvent, useState } from 'react';
import Button from '../../Button';
import Picker from '../../Picker';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
import { SortIcon } from '../../HomeOwnerDashboard/HomeownerOnboarding/SortIcon';

interface ConstructionStagesSectionProps {
  propertyFormData: any;
  propertyStages: any[];
  propertyStatuses: any[];
  filterData: any[];
  onChange: (update: any) => void;
  onhandleStatusUpdate: (value: any, index: number, type: string) => void;
  onhandleStatusDelete: (index: number, obj: any) => void;
  setSequence: (ps: any) => void;
  onChangeRank: (data: any, index: number) => void;
  onAddNewConstructionStatus: (type: boolean) => void;
}

const ConstructionStagesSection = ({
  propertyFormData,
  propertyStages,
  propertyStatuses,
  filterData,
  onChange,
  onhandleStatusUpdate,
  onhandleStatusDelete,
  setSequence,
  onChangeRank,
  onAddNewConstructionStatus,
}: ConstructionStagesSectionProps) => {
  const [stageToDelete, setStageToDelete] = useState<{
    index: number;
    stage: any;
  } | null>(null);

  const handleConfirmDelete = (): void => {
    if (!stageToDelete) {
      return;
    }

    onhandleStatusDelete(stageToDelete.index, stageToDelete.stage);
    setStageToDelete(null);
  };

  return (
    <>
      <label className="input__label">Construction Status</label>
      {propertyFormData?.constructionStages?.length > 0 &&
        propertyFormData.constructionStages.map((ps: any, i: any) => (
          <div
            key={i}
            className="propertyForm"
            draggable={true}
            onDragStart={() => setSequence(ps)}
            onDrop={() => onChangeRank(ps, i)}
          >
            <div className="construction">
              <div className="construction1">
                <div className="construction2">
                  <div className="imageContainer">
                    <div style={{ paddingLeft: 25 }}>
                      <SortIcon />
                    </div>
                  </div>
                  <div className="stageContainer">
                    <label>
                      Select Stage<span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                      className="stages"
                      defaultValue=""
                      value={
                        ps && ps.new
                          ? propertyFormData.selectedStage || ''
                          : ps.id && ps.type === 'Custom Stage'
                            ? ps.type
                            : ps.id || ps.type
                      }
                      onChange={(e: any) =>
                        ps && ps.new
                          ? e.target.value === 'Custom Stage'
                            ? onChange({
                                selectedStage: e.target.value,
                                isCustomStageEnabled: true,
                              })
                            : onChange({
                                selectedStage: e.target.value,
                                isCustomStageEnabled: false,
                              })
                          : onhandleStatusUpdate(e.target.value, i, 'id')
                      }
                    >
                      <option value="" disabled>
                        Select stage
                      </option>
                      {[
                        ...propertyStages,
                        { id: 'Custom Stage', name: 'Custom Stage' },
                      ].map((stage, index) => (
                        <option key={index} value={stage.id}>
                          {stage.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {((propertyFormData?.selectedStage === 'Custom Stage' &&
                    !ps.id) ||
                    ps.type === 'Custom Stage' ||
                    (ps.id && ps.type === 'Custom Stage')) && (
                    <div className="stageContainer">
                      <input
                        placeholder="Custom stage"
                        type="text"
                        className="custominput"
                        value={
                          ps && ps.new
                            ? propertyFormData.customStageName || ''
                            : ps.name
                        }
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          ps && ps.new
                            ? onChange({
                                customStageName: e.target.value,
                              })
                            : onhandleStatusUpdate(e.target.value, i, 'name')
                        }
                      />
                    </div>
                  )}
                  <div
                    className="stageContainer"
                    style={{ paddingRight: '0px' }}
                  >
                    <label>
                      Status<span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                      className="stages"
                      defaultValue=""
                      value={
                        ps && ps.new
                          ? propertyFormData.selectedStatus || ''
                          : ps.statusId
                      }
                      onChange={(e: any) =>
                        ps && ps.new
                          ? onChange({
                              selectedStatus: e.target.value,
                            })
                          : onhandleStatusUpdate(
                              e.target.value,
                              i,
                              'statusId'
                            )
                      }
                    >
                      <option value="" disabled>
                        Status
                      </option>
                      {propertyStatuses.map((status: any, index: any) => (
                        <option key={index} value={status.id}>
                          {status.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className="crossContainer"
                    style={{ cursor: 'pointer' }}
                  >
                    <img
                      src="/assets/cross.png"
                      style={{ marginTop: '7px', width: '18px' }}
                      onClick={() => setStageToDelete({ index: i, stage: ps })}
                      alt="Delete"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="dateContainer">
              <div className="dateContainer3">
                <Picker
                  placeholderText="Date"
                  required={false}
                  showPopperArrow={false}
                  selected={
                    ps && ps.new
                      ? propertyFormData.selectedDate || null
                      : ps.date && ps.date === '0001-01-01T00:00:00+00:00'
                        ? null
                        : ps.date
                          ? new Date(ps.date)
                          : null
                  }
                  onChange={(date) =>
                    ps && ps.new
                      ? onChange({ selectedDate: date })
                      : onhandleStatusUpdate(date, i, 'date')
                  }
                  label={undefined}
                />
              </div>
            </div>
          </div>
        ))}
      <div style={{ marginTop: 10 }}>
        <Button
          color="teal"
          size="small"
          label="+ Add New Construction Status"
          onClick={() =>
            onAddNewConstructionStatus(
              !(
                !propertyFormData.selectedStatus ||
                !propertyFormData.selectedStage
              )
            )
          }
          disabled={
            filterData && filterData.length > 0
              ? !propertyFormData.selectedStatus ||
                (propertyFormData?.selectedStage === 'Custom Stage' &&
                  !propertyFormData.customStageName) ||
                !propertyFormData.selectedStage
              : false
          }
        />
      </div>
      {stageToDelete && (
        <ConfirmationModal
          title="Delete Construction Stage"
          message="Are you sure you want to delete this construction stage?"
          warningMessage="This action cannot be undone."
          confirmLabel="Delete"
          cancelLabel="Cancel"
          onConfirm={handleConfirmDelete}
          onCancel={() => setStageToDelete(null)}
          variant="danger"
        />
      )}
    </>
  );
};

export default ConstructionStagesSection;
